import React from 'react'

import { useAuth } from '@affiliate-cabinet/auth'
import { useI18n } from '@affiliate-cabinet/i18n'
import { Badge, ButtonVariantEnum, Group, Link, Skeleton, Text } from '@affstore-ds/uikit'

import { handleNavigate } from '../../../../shared/navigation/handleNavigate'
import { paymentsTabSettings } from '../../../../shared/navigation/NavMenuData'
import { useNavigationContainer } from '../../../../shared/providers/NavigationContainer'
import { routes } from '../../../../shared/routes'
import { headerMainTranslationKeys } from '../../translations/headerMain.translationKeys'

import { useGetNextPaymentDate } from '../../../../entities/hooks/useGetNextPaymentDate'

export const PaymentInfo = () => {
  const { i18n } = useI18n()
  const {
    auth: { user },
  } = useAuth()

  const { redirect } = useNavigationContainer()

  const { nextPaymentDateIsFetching, paymentDate } = useGetNextPaymentDate()

  const paymentsHref = routes.ROUTES_PAYMENTS.paymentsTab.replace(':tabValue', paymentsTabSettings.regularAndRequests)

  if (!(user?.is_onboarding_passed && paymentDate)) {
    return null
  }

  return nextPaymentDateIsFetching ? (
    <Skeleton width={248} height={32} />
  ) : (
    <Group gap={12}>
      <Text colorVariant="greyIron.18" elementSize="s" elementVariant="important">
        {i18n.t(headerMainTranslationKeys.paymentsNextPayment)}
      </Text>
      <Link elementVariant={ButtonVariantEnum.SecondaryMainLine} href={paymentsHref} onClick={handleNavigate(redirect, paymentsHref)}>
        <Badge elementSize="l" elementVariant="header">
          {paymentDate}
        </Badge>
      </Link>
    </Group>
  )
}
